/**
 * Created by jiachenpan on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// Notification
export function SuccessNotify(obj, msg) {
  obj.$notify({
    title: 'Success',
    message: msg,
    type: 'success',
    duration: 2000
  })
}

export function WarningNotify(obj, msg) {
  obj.$notify({
    title: 'Warning',
    message: msg,
    type: 'warning',
    duration: 2000
  })
}

export function ErrorNotify(obj, msg) {
  obj.$notify.error({
    title: 'Error',
    message: msg,
    duration: 2000
  })
}

// Message
export function SuccessMessage(obj, msg) {
  obj.$message({
    message: msg,
    type: 'success'
  })
}

export function WarningMessage(obj, msg) {
  obj.$message({
    message: msg,
    type: 'warning'
  })
}

export function ErrorMessage(obj, msg) {
  obj.$message.error(msg)
}

// String
export function isNotEmpty(str) {
  return str !== null && str !== undefined && str.length > 0
}

// 分离权限
export function getAction(actions, targetid) {
  for (const e of actions) {
    if (e.ActionID === targetid) {
      return e
    }
  }
  return {}
}

// 格式化日期
export function formatDate(today) {
  const year = today.getFullYear()
  let month = today.getMonth() + 1
  let day = today.getDate()
  month = month >= 1 && month <= 9 ? `0${month}` : month
  day = day >= 1 && day <= 9 ? `0${day}` : day
  return `${year}-${month}-${day}`
}

// 格式化日期时间
export function formatDateTime(date) {
  const datetime = new Date(date)
  const year = datetime.getFullYear()
  let month = datetime.getMonth() + 1
  let day = datetime.getDate()
  let hour = datetime.getHours()
  let minute = datetime.getMinutes()
  let second = datetime.getSeconds()
  month = month >= 1 && month <= 9 ? `0${month}` : month
  day = day >= 1 && day <= 9 ? `0${day}` : day
  hour = hour >= 1 && hour <= 9 ? `0${hour}` : hour
  minute = minute >= 1 && minute <= 9 ? `0${minute}` : minute
  second = second >= 1 && second <= 9 ? `0${second}` : second
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}

// 判断是否是今天
export function isToday(date) {
  return formatDate(new Date()) === formatDate(new Date(date))
}

// 判断d1大于等于d2
export function compareDate(d1, d2) {
  return new Date(d1).getTime() >= new Date(d2).getTime()
}

// // 昨天
// function yestday() {
//   var date = new Date()
//   var today = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
//   return new Date(today - 24 * 3600 * 1000)
// }

// // 判断是否是昨天
// export function isYesterday() {
//   return formatDate(new Date()) === formatDate(new Date(yestday()))
// }



// WEBPACK FOOTER //
// ./src/utils/index.js